import { useLoaderData } from 'react-router';

export const useTypedLoaderData = <T>() => {
  return useLoaderData() as T;
};
